import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [
      { title: "Terms of Service — CoderLity" },
      { name: "description", content: "The terms that govern your use of CoderLity's services, software and websites." },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/terms" }],
  }),
});

function TermsPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms of Service"
      sub="The ground rules for working with CoderLity."
      updated="May 1, 2026"
      sections={[
        { heading: "Acceptance", body: "By using our services you agree to these terms. If you do not agree, please do not use the services." },
        { heading: "Accounts", body: "You are responsible for the security of your account credentials and all activity under your account." },
        { heading: "Acceptable use", body: "No unlawful, abusive, or infringing activity. No attempts to disrupt, reverse engineer, or overload our infrastructure." },
        { heading: "Payments", body: "Fees are billed in advance and are non-refundable except as required by law or our Refund Policy." },
        { heading: "Termination", body: "We may suspend or terminate services for breach of these terms, with or without notice." },
        { heading: "Liability", body: "Services are provided 'as is'. To the maximum extent permitted by law, CoderLity is not liable for indirect or consequential damages." },
      ]}
    />
  );
}
